/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useDownloadEra
 */
import { useMutation, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents, { Events, Messages } from '@veritable/common/utils/appEvents';
import { downloadBlobFile } from '@veritable/common/utils';

interface IProps {
	paymentReconciliationId: string;
}

const useDownloadEra = ({ title }: { title: string }): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	return useMutation({
		mutationFn: async ({ paymentReconciliationId }) => {
			const { data } = await api.PaymentReconciliationApi.downloadEraDetail({ paymentReconciliationId }, { responseType: 'blob' });
			downloadBlobFile(data, title || 'blob-download', 'application/pdf', 'download');
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess('Download complete');
		},
		onMutate: () => {
			AppEvents.publish(Events.Loading, Messages.DownloadingFile);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDownloadEra;
